<div class="home-section">
  <div class="banner">
    <div class="banner-content">
      <h1><span class="emphasis">cloud</span>Serve</h1>
      <p class="subtitle">Create cloud accounts or subscriptions using your owned ASMS.</p>

      <button 
        mat-button 
        id="newAccount" 
        [matMenuTriggerFor]="cloudMenu" 
        #cloudMenuTrigger="matMenuTrigger"
        [class.cloud-menu-open]="cloudMenuTrigger.menuOpen">
          Create Cloud Resource
          <img class="dropdown-arrow" src="../../assets/images/dropdown-arrow.png"/>
      </button>
      <mat-menu class = "cloudMenu" #cloudMenu="matMenu" yPosition="below" >
        <button mat-menu-item [routerLink]="'/form/azure'">
          Azure
        </button>
        <button mat-menu-item [routerLink]="'/form/aws'">
          AWS
        </button>
      </mat-menu>

    </div>
  </div>

  <div class="accounts" *ngIf="!isAccountsLoading">
    <div class="no-accounts" *ngIf="accounts.length === 0">
      <p>Create a new account or subscription with the green button above. </p>
      <mat-stepper orientation="vertical" [linear]="true">
        <mat-step [completed]="true" [editable]="false" state="index">
          <ng-template matStepperIcon="done" let-index="index">
            {{ index + 1 }}
          </ng-template>
          <ng-template matStepLabel>
            <label class="stepper-label">
              Create a new account or subscription with the green button above.
            </label>
          </ng-template>
        </mat-step>

        <mat-step [completed]="true" [editable]="false" state="index">
          <ng-template matStepperIcon="done" let-index="index">
            {{ index + 1 }}
          </ng-template>
          <ng-template matStepLabel>
            <label class="stepper-label">
              Return to this page to view your account and subscription status.
            </label>
          </ng-template>
        </mat-step>
      </mat-stepper>
    </div>
    <div class = "has-accounts" *ngIf="accounts.length > 0">
        <p class="title">Existing Accounts </p> 
        <div class = "accounts-all">
          <account-summary *ngFor="let account of accounts" [account]="account">
          </account-summary>
        </div>
    </div>
  </div>
  
  <skeleton *ngIf="isAccountsLoading"
        [fullWidth]="true" 
        [width]="500" [height]="220" 
        [minWidth]="'874px'"
        >
  </skeleton>
  

</div>
